import { gql } from '@apollo/client';

export const ESTIMATE_PERIOD_BALANCE = gql`
 mutation Mutation($input: PaymentSearchInput) {
  estimatePeriodBalance(input: $input)
}
`;
